export default function (err) {
  if (err.graphQLErrors && err.graphQLErrors.length > 0) {
    return err.graphQLErrors[0].message
  } else if (err.networkError) {
    return err.networkError.message
  } else {
    return err.message
  }
}
